import React, { ComponentProps, ReactNode } from 'react';

import PropTypes from 'prop-types';

import ActivityText from './ActivityText';
import ActivityCard from '../ActivityCard';

type TextActivityCardProps = ComponentProps<typeof ActivityCard> & {
  text: ReactNode;
};

/**
 * TextActivityCard component. Describes a single text change activity.
 */
const TextActivityCard = React.forwardRef<
  HTMLDivElement,
  TextActivityCardProps
>(({ text, children, ...props }, ref) => {
  return (
    <ActivityCard ref={ref} {...props}>
      <ActivityText text={text} />
      {children}
    </ActivityCard>
  );
});

TextActivityCard.displayName = 'TextActivityCard';

TextActivityCard.propTypes = {
  ...ActivityCard.propTypes,
  /** Generic activity text to render */
  text: PropTypes.any.isRequired,
};

export default TextActivityCard;
